<template>
  <v-container fluid class="get-started d-flex flex-column">
    <div class="d-flex align-center">
      <router-link to="/">
        <v-img src="@/assets/logo.png" contain style="width: 150px" class="ma-3"></v-img>
      </router-link>
      <v-progress-linear :value="percent"></v-progress-linear>
    </div>
    <v-stepper class="elevation-0 flex-grow-1" v-model="step">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="5">
                <v-card tile flat class="d-flex flex-column justify-space-between fill-height">
                  <div>
                    <v-card-title>
                      <h3 class="display-1 font-weight-bold text-break">
                        {{ $t('get-started.card.title') }}
                      </h3>
                    </v-card-title>
                    <v-card-subtitle>
                      <p class="subtitle-1 text-break">{{ $t('get-started.card.subtitle') }}</p>
                    </v-card-subtitle>
                  </div>
                  <v-card-text>
                    <v-img
                      src="../assets/world-map.png"
                      lazy-src="https://picsum.photos/id/11/10/6"
                    >
                    </v-img>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col
                cols="12"
                md="7"
              >
                <v-card outlined max-width="416px" class="ma-auto">
                  <v-card-title class="text--primary">
                    <h3 class="title font-weight-bold text-break">
                      {{$t('naviForm.signup')}}
                    </h3>
                  </v-card-title>
                  <v-card-subtitle>
                      {{$t('naviForm.already-navigate')}}
                    <a
                      v-if="$store.state.accountType === 'brand'"
                      class="font-weight-medium"
                      :href="brandWeb">
                      {{$t('naviForm.login-here')}}
                    </a>
                    <a v-else
                      class="font-weight-medium"
                      :href="kolWeb">
                      {{$t('naviForm.login-here')}}
                    </a>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-form
                      v-model="isFormValid"
                      ref="signUpForm"
                    >
                      <v-text-field
                        :label="$t('naviForm.email')"
                        required
                        placeholder="yourname@example.com"
                        :rules="emailRules"
                        :hint="$t('eoiForm.enter-email-hint')"
                        type="phone"
                        v-model="form.email">
                      </v-text-field>
                      <v-text-field
                        v-if="$store.state.accountType ==='brand'"
                        :label="$t('naviForm.name')"
                        :placeholder="$t('naviForm.your-name')"
                        :rules="[rules.required]"
                        v-model="form.name"
                        :required="$store.state.accountType ==='brand'"
                        type="text"
                      />
                      <vue-tel-input-vuetify
                        v-if="$store.state.accountType ==='brand'"
                        :label="$t('naviForm.mobile')"
                        :required="$store.state.accountType ==='brand'"
                        valid-characters-only
                        validate-on-blur
                        @validate="checkMobileNumber"
                        :rules="[rules.mobile]"
                        :placeholder="$t('naviForm.enter-mobile')"
                      ></vue-tel-input-vuetify>
                      <v-text-field
                        :label="$t('naviForm.password')"
                        required
                        :placeholder="$t('naviForm.gt-eight-characters')"
                        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPwd ? 'text' : 'password'"
                        @click:append="showPwd = !showPwd"
                        :rules="[rules.password]"
                        v-model="form.password"></v-text-field>
                      <v-text-field
                        v-if="$store.state.accountType ==='influencer'"
                        v-model="form.referrer"
                        :label="$t('naviForm.invite-code')" />
                      <div
                        class="caption" v-html="$t('naviForm.by-below-next')">
                      </div>
                      <div class="text-right mt-3">
                        <v-btn color="primary" class="" @click="next">
                          {{$t('naviForm.next')}}
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </div>
                    </v-form>

                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <!-- step 2 -->
        <v-stepper-content step="2" class="pa-0">
          <v-container fluid>
            <v-row>
              <v-col
                cols="12"
              >
                <v-card class="text-center ma-auto" max-width="416">
                  <v-img></v-img>
                  <v-card-title class="text--primary justify-center text-break">
                        <h3 class="headline font-weight-bold">
                          {{ $t('get-started.step-2.title') }}
                        </h3>
                  </v-card-title>
                  <v-card-subtitle>
                    <div>{{ $t('naviForm.send-code-info') }}</div>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row justify="center" align="center">
                      <v-col>
                        <verification-code-input
                          v-if="!loading"
                          :wrong="isWrongCode"
                          ref="shortCode"
                          item-class="short-code"
                          @finishEvent="signUp"
                          item-active-class="short-code-active"
                          item-wrong-class="short-code-wrong"/>
                        <v-progress-circular v-else color="primary" indeterminate />
                      </v-col>
                      <v-col cols="12" v-if="!countDownInProgress">
                        <v-btn
                          :disabled="loading"
                          block
                          text
                          @click="onClickResendCode"
                          color="primary accent-4"
                          class="text-none"
                        >
                          {{$t('naviForm.not-receive-code')}}
                        </v-btn>
                        <v-btn
                          :disabled="loading"
                          @click="step -= 1"
                          block
                          text
                          color="primary accent-4"
                          class="text-none"
                        >
                          {{$t('naviForm.signup-different-email')}}
                        </v-btn>
                      </v-col>
                      <v-col cols="12" v-if="countDownInProgress && !loading">
                        <v-progress-circular :value="countDown" color="primary" size=40>
                          {{ timer }}
                        </v-progress-circular>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      text
                      color="deep-purple accent-4"
                      id="open_intercom_chat"
                    >
                      {{$t('naviForm.need-help')}}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <!-- step 3 -->
        <v-stepper-content step="3" class="pa-0">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="5">
                <v-card flat>
                  <v-card-title>
                    <h3 class="display-1 font-weight-bold text-break">
                      Introduce yourself to the community
                    </h3>
                  </v-card-title>
                  <v-card-subtitle>
                    <p class="subtitle-1 text-break">Share an overview of about your brand/company This will show up at the top of your navigate profile.</p>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-img
                      src="../assets/interest.png"
                      lazy-src="https://picsum.photos/id/11/10/6"
                    >
                    </v-img>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-row>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title class="text--primary">
                        <h3 class="title font-weight-bold text-break">
                          User Profile
                        </h3>
                        <v-spacer/>
                        <v-btn class="text-none" text>Skip for now</v-btn>
                      </v-card-title>
                      <v-card-subtitle>
                        This won't take much time to complete
                      </v-card-subtitle>
                      <v-card-text>
                        <v-form>
                          <v-text-field v-model="form.brandName" label="Company name" />
                          <v-text-field v-model="form.website" label="Website" />
                        </v-form>
                      </v-card-text>
                      <v-card-title class="text--primary">
                      <h3 class="title font-weight-bold text-break">
                        I'm interested in
                      </h3>
                      </v-card-title>
                      <v-card-subtitle>
                        Select up to 5 categories
                      </v-card-subtitle>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="4" v-for="(i, index) in industries" :key="i.name">
                            <v-card outlined @click="onClickIndustry(index)">
                              <v-list-item>
                                <v-list-item-avatar
                                  size="36"
                                  color="grey"
                                ></v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title class="subtitle-2">{{i.name}}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-icon v-if="i.selected">
                                  <v-icon color="green">mdi-check</v-icon>
                                </v-list-item-icon>
                              </v-list-item>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="signUp" dark>Save and continue</v-btn>
                      </v-card-actions>
                      <v-card-actions>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="4" class="pa-0">
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="5">
                <v-card flat>
                  <v-card-title>
                    <h3 class="display-1 font-weight-bold text-break">
                      {{ $t('naviForm.almost-done') }}
                    </h3>
                  </v-card-title>
                  <v-card-subtitle>
                    <p class="subtitle-1 text-break">{{$t('naviForm.confirm-email', {email: form.email})}}</p>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-img
                      src="../assets/interest.png"
                      lazy-src="https://picsum.photos/id/11/10/6"
                    >
                    </v-img>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="5">
          <v-container fluid>
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="5"
              >
                <v-card>
                  <v-card-title class="text--primary justify-center text-center">
                    <span class="display-1 font-weight-bold">Check your email</span>
                  </v-card-title>
                  <v-card-subtitle class="justify-center text-center">
                    We've send the activation code to your email. <br/> didn't receive the code? <a @click="resendCode">resend now</a>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-row>
                      <v-col v-for="(digit, i) in 6">
                        <v-text-field  :ref="'input-' + i" :autofocus="i === 0" class="centered-input" v-model="code[i]" flat outlined  @keyup="nextKey(i)"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
        <v-stepper-content step="6">
          <v-container fluid>
            <v-row
              align="center"
              justify="center"
            >
              <v-col
                cols="12"
                sm="8"
                md="5"
              >
                <v-card>
                  <v-card-title class="text--primary justify-center text-center">
                    <span class="display-1 font-weight-bold">Get social</span>
                  </v-card-title>
                  <v-card-subtitle class="justify-center text-center">
                    You need at least have 1 active public social media account to be approved as influencer
                  </v-card-subtitle>
                  <v-card-text>
                    <v-text-field label="Instagram" dense prepend-icon="mdi-instagram"></v-text-field>
                    <v-text-field label="WeChat" dense prepend-icon="mdi-wechat"></v-text-field>
                    <v-text-field label="Weibo" dense prepend-icon="mdi-sina-weibo"></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer/>
                    <v-btn text small>skip</v-btn>
                    <v-btn>submit</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-snackbar v-model="codeSnackbar"
      :top="true"
      color="#2196F3">
      {{ codeMessage }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import VerificationCodeInput from 'vue-verification-input';

export default {
  name: 'GetStart',
  components: {
    VerificationCodeInput,
  },
  data() {
    return {
      kolWeb: process.env.NODE_ENV === 'uat' ? 'http://120.76.101.229:9530' : 'https://kol.navigate.network',
      brandWeb: process.env.NODE_ENV === 'uat' ? 'http://120.76.101.229:9529' : 'https://app.navigate.network',
      apiWeb: process.env.NODE_ENV === 'uat' ? 'http://120.76.101.229:3000' : 'https://api.navigate.network',
      phone: '',
      step: 1,
      loading: false,
      percent: 20,
      showPwd: false,
      code: [],
      currentKey: 0,
      isWrongCode: false,
      countDown: 100,
      countDownInProgress: false,
      timer: 60,
      form: {
        email: this.$store.state.email,
        brandName: '',
        mobile: '',
        type: this.$store.state.accountType,
        name: '',
        password: '',
        referrer: '',
        verificationCode: '',
      },
      industries: [
        {
          name: 'a',
          selected: false,
        },
        {
          name: 'b',
          selected: false,
        },
        {
          name: 'c',
          selected: false,
        },
        {
          name: 'd',
          selected: false,
        },
        {
          name: 'e',
          selected: false,
        },
        {
          name: 'f',
          selected: false,
        },
      ],
      isFormValid: false,
      value: true,
      isMobileValid: false,
      companyRules: [
        v => !!v || 'required',
      ],
      emailRules: [
        v => !!v || this.$t('naviForm.emailRequire'),
        v => /.+@.+\..+/.test(v) || this.$t('naviForm.emailValid'),
      ],
      rules: {
        required: value => !!value || this.$t('naviForm.required'),
        password: (value) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/;
          return (
            pattern.test(value)
            || this.$t('naviForm.password-strength')
          );
        },
        mobile: () => this.isMobileValid || this.$t('naviForm.valid-mobile'),
      },
      lang: 'en',
      codeSnackbar: false,
      codeMessage: '',
    };
  },
  computed: {
    strength() {
      const { length } = this.form.password;
      const strength = {
        Strong: length >= 14,
        Medium: length < 14 && length >= 8,
        Weak: length < 8,
      };
      return Object.keys(strength)
        .find(key => strength[key]);
    },
    passwordClasses() {
      return `password-strength--${this.strength}`;
    },
  },
  mounted() {
    // eslint-disable-next-line prefer-destructuring
    this.lang = localStorage.lang ? localStorage.lang.split('-')[0] : navigator.languages[0].split('-')[0];

    if (this.$store.state.accountType === '') {
      this.$router.push('/');
      // this.$store.state.accountType = 'brand';
    }
  },
  methods: {
    async next(type) {
      this.$refs.signUpForm.validate();
      if (this.isFormValid) {
        // this.sendSmsCode();
        await this.createUser().then((res) => {
          console.log(res, '090');
          this.percent += 30;
          this.step += this.$store.state.accountType === 'influencer' ? 3 : 1;
        }).catch((err) => {
          console.log(err, 989);
          const { message } = err.response.data;
          this.codeSnackbar = true;
          this.codeMessage = message;
          console.log(message);
        });
      }
    },
    async createInfluencer(params) {
      const api = `${this.apiWeb}/users/influencer`;

      const res = await axios.post(api, Object.assign(params, { lang: this.lang }), {
        headers: {
          language: this.lang,
        },
      });
      return res;
    },
    async createUser() {
      let params = {};
      if (this.form.type === 'influencer') {
        params = {
          email: this.form.email,
          password: this.form.password,
          type: this.form.type,
          referrer: this.form.referrer,
          lang: this.lang,
        };
        const res = await this.createInfluencer(params);
        return res;
      }
      const code = await this.sendSmsCode();
      return code;


      // const userData = axios.post(`${this.apiWeb}/users`, params);
      // return userData;
    },
    onClickIndustry(i) {
      this.industries[i].selected = true;
    },
    checkMobileNumber(e) {
      this.isMobileValid = e.valid;
      if (e.valid) {
        console.log(e);
        this.form.mobile = e.number.e164;
      }
    },
    countDownTimer() {
      if (this.countDown > 0 && this.timer > 0) {
        setTimeout(() => {
          this.countDown -= 1.66;
          this.timer -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.countDownInProgress = false;
        this.countDown = 100;
        this.timer = 60;
      }
    },
    async onClickResendCode() {
      await this.sendSmsCode();
      this.countDownInProgress = true;
      this.countDownTimer();
    },
    pre() {
      this.step -= 1;
      this.percent -= 20;
    },
    async sendSmsCode() {
      const api = `${this.apiWeb}/phone/send-verification-code`;
      const res = await axios.post(api, { phone: this.form.mobile }, {
        headers: {
          language: this.lang,
        },
      });
      return res;
    },
    resendCode(e) {
    },
    signUp(str) {
      this.loading = true;
      const api = `${this.apiWeb}/users/brand`;
      delete this.form.referrer;
      this.form.verificationCode = Number(str);
      this.form.lang = this.lang;
      axios.post(api, this.form, {
        headers: {
          language: this.lang,
        },
      })
        .then((res) => {
          console.log(res.data);
          this.step += 2;
          this.percent += 30;
        })
        .catch((err) => {
          this.isWrongCode = true;
          this.loading = false;
          const { message } = err.response.data;
          this.codeSnackbar = true;
          this.codeMessage = message;
          console.log(message, err.response.data);
        });
    },
    verifyEmail() {
      const api = `${this.apiWeb}/authmanagement`;
      axios.post(api, {
        action: 'verifySignupShort',
        value: {
          user: {
            email: this.form.email,
          },
          token: this.code.join(''),
        },
      });
    },
    nextKey(i) {
      if (i < 5) {
        const key = `input-${i + 1}`;
        this.$refs[key][0].focus();
      } else {
        this.verifyEmail();
      }
    },
  },
};
</script>

<style>
  .centered-input >>> input {
    text-align: center;
    font-size: 30px
  }
  .short-code {
    height: 50px;
    width: 50px;
    border: 1px solid #999;
    background: #fff;
    border-radius: 8px;
    font-size: 26px;
    color: #ccc;
  }
  .short-code-active {
    border: 1px solid #6200ea;
    color: #6200ea;
  }
  .short-code-wrong {
    border: 1px solid red;
    color: red;
  }
</style>
